const dialogs:HTMLElement[]=[]
/** 只约束最上层弹窗的键盘导航，关闭后恢复原焦点，不改变弹窗布局及业务按钮。 */
export function trapModalFocus(dialog:HTMLElement,close:()=>void){
  const previous=document.activeElement as HTMLElement|null;dialogs.push(dialog)
  const targets=()=>Array.from(dialog.querySelectorAll<HTMLElement>('button,a[href],input,select,textarea,[tabindex]:not([tabindex="-1"])')).filter(node=>!node.hasAttribute('disabled') && node.getClientRects().length>0)
  const focus=()=>{(targets()[0] || dialog).focus()}
  const key=(event:KeyboardEvent)=>{
    if(dialogs[dialogs.length-1]!==dialog)return
    if(event.key==='Escape'){event.preventDefault();event.stopPropagation();close();return}
    if(event.key!=='Tab')return
    const values=targets(),active=document.activeElement,index=values.indexOf(active as HTMLElement)
    if(!values.length){event.preventDefault();dialog.focus();return}
    if(index<0 || event.shiftKey && index===0 || !event.shiftKey && index===values.length-1){event.preventDefault();(event.shiftKey?values[values.length-1]:values[0]).focus()}
  }
  document.addEventListener('keydown',key,true);focus()
  return ()=>{document.removeEventListener('keydown',key,true);const index=dialogs.indexOf(dialog);if(index>=0)dialogs.splice(index,1);if(previous?.isConnected)previous.focus()}
}
